/* eslint-disable-next-line */
export const LEGAL_TEXT = '* Online Only. While Supplies Last. Free delivery excludes major appliances. Countdown clock is based on Eastern Standard Time (EST). All offers reset at 3 AM ET, 12 AM PST, 1 AM MST & 2 AM CST';
